import React from 'react';
import { Link } from 'react-router-dom';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import * as url from '../../../ressources/glossaires/glossaire_liens_pages';
import S from './Widget.module.scss';
import logoArgos from "../../../ressources/accueil/argos ITM.png";

const WidgetCommentCaMarche = () => {
  return (
    <div className={[S.widget, S.widgetSmall, S.widgetHelp].join(' ')}>
      <div className={S.helpContainer}>
        <div className={S.helpLeft}>
          <Link to={url.Formation} className={S.helpLink}>
            <span className={S.helpTitle}>{checkMot('comment_ca_marche')}</span>
          </Link>
        </div>
        <div className={S.helpRight}>
          <img src={logoArgos} alt="Argos ITM" className={S.logoArg} />
        </div>
      </div>
    </div>
  );
};

export default WidgetCommentCaMarche;
